// Bahasa Indonesia
export default {
  translation: {
    app_name: 'Agora',
    tagline: 'Tempat Hobi Membangun Komunitas',
    nav_explore: 'Jelajahi',
    nav_find_folks: 'Cari Teman',
    nav_sign_in: 'Masuk',
    nav_join_free: 'Daftar Gratis',
    nav_sign_out: 'Keluar',
    nav_my_profile: 'Profil Saya',
    nav_notifications: 'Notifikasi',
    auth_register: 'Buat Akun',
    auth_login: 'Masuk',
    auth_name: 'Nama Lengkap',
    auth_email: 'Alamat Email',
    auth_password: 'Kata Sandi',
    auth_age: 'Usia Anda',
    auth_city: 'Kota',
    auth_building: 'Apartemen / Perumahan',
    auth_country: 'Negara',
    auth_currency: 'Mata Uang',
    auth_locale: 'Bahasa dan Wilayah',
    auth_already_have_account: 'Sudah punya akun?',
    auth_no_account: 'Belum punya akun?',
    postcode_label: 'Kode Pos',
    postcode_placeholder: 'mis. 10110',
    profile_edit: 'Edit Profil',
    profile_bio: 'Bio',
    profile_interests: 'Minat',
    profile_location: 'Lokasi',
    profile_theme: 'Tema Tampilan',
    profile_currency_settings: 'Mata Uang & Wilayah',
    profile_save: 'Simpan Perubahan',
    profile_cancel: 'Batal',
    group_join: 'Bergabung',
    group_leave: 'Keluar Grup',
    group_members: 'Anggota',
    group_chat: 'Obrolan',
    group_events: 'Acara',
    group_shop: 'Toko',
    group_campaigns: 'Kampanye',
    group_about: 'Tentang',
    group_full: 'Penuh',
    group_open: 'Terbuka',
    tip_send: 'Kirim Tip',
    tip_amount: 'Jumlah',
    tip_message: 'Pesan (opsional)',
    wallet_coins: 'koin',
    wallet_balance: 'Saldo',
    tips_earned: 'diperoleh',
    event_register: 'Daftar',
    event_unregister: 'Batalkan Pendaftaran',
    event_ticket_price: 'Tiket',
    event_free: 'Gratis',
    event_capacity: 'Kapasitas',
    event_registered: 'terdaftar',
    no_results: 'Tidak ada hasil',
    loading: 'Memuat…',
    error_generic: 'Terjadi kesalahan. Silakan coba lagi.',
  }
};
